import { FormInput } from "../../components/form-input"
import { cpfValidator, mailValidator, sizeValidator } from "../../../../utils/validators";
import { useEffect, useState, useRef } from "react";

import { Icon } from "../../../../components/icon";
import Arrow from "../../../../assets/icons/arrow-right.svg";
import Loading from "../../../../assets/icons/loading.svg"
import {
    cpfMask,
    letraMask,
    cellMask,
} from "../../../../utils/masks";


export const SeusDados = ({ nextStep }) => {
    const [loadingSend, setLoadingSend] = useState(false)

    const formRef = useRef(null);   


    const [isValid, setIsValid] = useState(false);

    const [inputState, setInputState] = useState(
        {
            nomecompleto: false,
            cpf: false,
            celular: false,
            email: false,
           
        })

    const updateField = (field, state) => {
        setInputState(oldState => {
            const ccpy = { ...oldState }
            ccpy[field] = state;
            return { ...ccpy }
        })

    }


   
    
    useEffect(() => {
        setIsValid(true);
        for (const v of Object.values(inputState)) {
            if (v === false) {
                setIsValid(false);
                break;
            }
        }
    }, [inputState])

    const onSubmit = async (e) => {
        e.preventDefault();
        if(isValid){
            registerCompanyData(e.target)
        }

    }

    const [apiError, setApiError] = useState("")
    function registerCompanyData(form){
        setLoadingSend(true);
        var data= JSON.stringify(
            {
                "id_usuario":0,
                "nm_usuario": form.nomecompleto.value,
                "cd_cpf": form.cpf.value.replace("-", "").replace(".", ""),
                "nu_cel": form.celular.value,
                "str_email": form.email.value ,
                "cd_forma_de_cadastro": 0
               
                
              }
        )
        fetch(process.env.REACT_APP_API_URL+'Register_PF',
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "POST",
                body: data
            })
            .then((response)=>{ 
                response.json().then((json)=>{
                    console.log(json)
                    if(json.hasError===false) {
                        nextStep();
                    }else{
                        setApiError(json.description)
                        setTimeout(() => {setApiError("")}, 1500)
                    }
                    })

            }).finally(()=>{setLoadingSend(false);})

    }


    return (
        <form ref={formRef} className='conta-content' onSubmit={onSubmit}>
            <div className='conta-content-section'>
                <h2 className="conta-section-title">Seus Dados</h2>
                <div className="form-section">
                    <div className="form-section-row">
                        <FormInput id="nomecompleto" label={"Nome Completo"}
                            validators={[
                                { func: sizeValidator, argument: 3 }
                            ]}
                            mask={
                                letraMask
                            }
                            updateField={updateField}
                        />

                        <FormInput id="cpf" label={"CPF"}
                            validators={[
                                { func: cpfValidator}
                            ]}
                            mask={
                                cpfMask
                            }
                            updateField={updateField} />
                    </div>

                    <div className="form-section-row">
                        <FormInput id="celular" label={"Celular"}
                            placeholder="(XX) XXXXX-XXXX"
                            validators={[
                                { func: sizeValidator,argument:15  }
                            ]}
                            mask={cellMask}

                            updateField={updateField}
                        />

                        <FormInput id="email" label={"E-Mail"} updateField={updateField}
                            validators={[
                                { func: mailValidator }
                            ]}
                        />
                    </div>

         

                   
                </div>
                
                
            </div>


            <div className='conta-content-footer'>
                <div className='divider'></div>
                <button type="submit" disabled={!isValid || loadingSend} className='step-button next-step'>

                    <span className="text">Prosseguir</span>
                    <span className='icon'> <Icon icon={loadingSend ? Loading : Arrow} size={18} /> </span>
                   
                </button>
            </div>
            {apiError !== "" && <div style={{width:"100%", display:"flex", justifyContent:"end", marginTop:"10px"}}> 
                <span style={{color:"red"}}> {apiError} </span>
            </div>}
        </form>

    )
}
